import React, { Component } from "react";
import PropTypes from "prop-types";
// import { Query } from "@apollo/client/react/components"; // TODO: Replaced with REST hook
import DataTable from "../../../common/components/data-table/DataTable";
import LoadingAnimation from "../../../common/components/base/LoadingAnimation";
import ChallengePanel from "../ChallengePanel";
// import { GET_CHALLENGE } from "./queries"; // TODO: Replaced with REST hook
import { useChallenge } from '../../../hooks/useChallenge';

// Wrapper component to use hooks with class component
const FirstStepQueryWrapper = (props) => {
  const { data, isFetching: isLoading, error } = useChallenge(props.challengeType);
  console.log("Challenge data in FirstStepQueryWrapper isLoading:", isLoading);
  if (isLoading) return <LoadingAnimation />;
  if (error) return <div>Error! {error.message}</div>;

  return <FirstStepQueryClass {...props} challengeData={data} />;
};

class FirstStepQueryClass extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { tableHeader, tableColumns, editUrl, handleEditClick, CustomComponent, customComponentProps, challengeData } = this.props;
    
    let challenge = typeof challengeData === 'string' ? JSON.parse(challengeData.challengeDefinition) : challengeData.challengeDefinition;
    let records = [];
    let StepCountDownTime = challenge.steps[0]?.countdownTime ? challenge.steps[0].countdownTime : "0"; 
    if (challenge.records) {
      records = challenge.records
    }
    
    return (
      <div>
        {(() => {
          if (CustomComponent)
            return <CustomComponent {...customComponentProps} />;
          else
            return <DataTable
              header={tableHeader}
              editUrl={editUrl || ""}
              columns={tableColumns}
              records={{ records: records }}
              keyColumn="_id"
              handleEditClick={handleEditClick}
              first={e => e.preventDefault()}
              columnsToHide={["username"]}
            />;
        })()}
        <ChallengePanel
          step={0}
          time={StepCountDownTime}
          description={challenge.challengeDescription}
          coach={challenge.coach}
          challengeTitle={challenge.challengeTitle}
          challengeIsValidation={challenge.isValidation}
          challengeDifficulty={challenge.challengeDifficulty}
          challengeAverageTime={challenge.averageTime}
        />
      </div>
    );
  }
}

FirstStepQueryWrapper.propTypes = {
  tableHeader: PropTypes.string.isRequired,
  tableColumns: PropTypes.array.isRequired,
  editUrl: PropTypes.string,
  challengeType: PropTypes.string.isRequired
};

FirstStepQueryWrapper.defaultTypes = {
  tableHeader: 'Table',
  tableColumns: [],
  editUrl: ''
};

export default FirstStepQueryWrapper;
